import { CUSTOM_FIELD_TYPES, KeyData, ObjectInstanceData, ObjectKeyVisibility, ObjectPropertyData } from "@/types/customFieldTypes";
import { File } from "./file";

export class ObjectInstance {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  customFieldId: string;
  objectShapeId: string;
  properties: ObjectProperty[];
  title: string;
  propelOrgId: string;

  constructor(params: ObjectInstanceData) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.customFieldId = params.customFieldId;
    this.objectShapeId = params.objectShapeId;
    this.properties = params.properties.map(property => new ObjectProperty(property));
    this.title = params.title;
    this.propelOrgId = params.propelOrgId || '';
  }
 }

export class ObjectKeyProperty {
  key: string;
  keyId: string;
  type: CUSTOM_FIELD_TYPES;
  inputType?: string;
  visibility: ObjectKeyVisibility;
  title: string;
  description: string;

  constructor(params: KeyData) {
    this.key = params.key;
    this.keyId = params.keyId;
    this.type = params.type;
    this.inputType = params.inputType;
    this.visibility = params.visibility;
    this.title = params.title || '';
    this.description = params.description || '';
  }
}

export class ObjectProperty extends ObjectKeyProperty {
  valueId: string;
  value: string;
  file?: File;

  constructor(params: ObjectPropertyData) {
    super(params);
    this.valueId = params.valueId;
    this.value = params.value;
    this.file = params.file ? new File(params.file) : undefined;
  }
}
